import { QuickLinkItem } from "./QuickLinkItem";
import qStyle from "./quicklink.module.scss";
import classNames from "classnames";

const QuickLinkData = [
  {
    title: "Calculators",
    description: "Body surface, weight, creatinine clearance",
    icon: "Calculator",
    logged: true,
    link: "/calculators",
  },
  {
    title: "Resources",
    description: "Summary tables, figures and useful PDFs",
    icon: "Resources",
    logged: false,
    link: "/resources",
  },
];

export const QuickLinks = ({ isLogged,  }) => {
  const headerStyle = classNames(
    qStyle.title,
    "semibold",
    qStyle.header,
    "size-16"
  );
  return (
    <div className="container">
      <div className={qStyle.sectionHeader}>
        <h2 className={headerStyle}>Quick Links</h2>
      </div>
      {QuickLinkData.filter(
        ({ logged }) => (isLogged && logged) || !logged
      ).map(({ icon, description, title, link }, index) => (
        <QuickLinkItem
          {...{ icon, description, title, link }}
          className="centered"
          key={`quick-${index}`}
        ></QuickLinkItem>
      ))}
    </div>
  );
};
